import toastManager from "../toastManager";

export const processRapidEntrySave = ({
  formData,
  rapidEntry,
  rapidEntryAction,
  rapidPatientUniqueId,
  rapidPatientFullName,
  setRapidPatientUniqueIdWarning,
  selectedExistingPatientId,
}) => {
  if (rapidEntry && rapidEntryAction) {
    if (rapidEntryAction === "save_to_new") {
      // Check that rapidPatientUniqueId is present
      if (!rapidPatientUniqueId) {
        toastManager(
          "warning",
          "Unique ID Required",
          "Unique ID is required to create a new patient. Please fill this field out."
        );
        setRapidPatientUniqueIdWarning(true);
        return false;
      } else {
        setRapidPatientUniqueIdWarning(false);
        formData.append("rapid_patient_unique_id", rapidPatientUniqueId);
        formData.append("rapid_patient_full_name", rapidPatientFullName);
      }
    } else if (rapidEntryAction === "save_to_existing") {
      if (!selectedExistingPatientId) {
        toastManager(
          "warning",
          "Select Existing Patient",
          "Please select an existing patient if you would like to the the entry to that patient."
        );

        return false;
      } else {
        formData.append(
          "selected_existing_patient_id",
          selectedExistingPatientId
        );
      }
    }
    formData.append("rapid_entry_action", rapidEntryAction);
  }

  return true;
};
